import { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useRoutes } from 'hookrouter';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Routes from '../routes/routes';
import {
  Box,
  Tooltip,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  Paper,
  FormControlLabel,
  DialogTitle,
  DialogActions,
  MenuItem,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SendIcon from '@material-ui/icons/Send';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import { v4 as uuidv4 } from 'uuid';
import CloudIcon from '@material-ui/icons/Cloud';
import DownloadIcon from '@material-ui/icons/GetApp';
import jsFileDownload from 'js-file-download';
import axios from 'axios';
import {
  getExisitingTemplates,
  getSpecificTemplates,
  setUploadSelector,
  getSelectedTemplateSelector,
  setInstanceSelector,
  getInstanceById,
  createInstance,
  setCreateInstanceSelector,
  resetUploadStates,
  setAllInstancesSelector,
  createInstanceMultiple,
} from '../../services/uploadSlice';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TablePagination from '@material-ui/core/TablePagination';
import * as XLSX from 'xlsx';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import {
  addTemplate,
  createTemplateId,
  setNewTemplateIdSelector,
  resetTemplateStates,
  setCreateTemplateSelector,
  toggleActive,
  setActiveToggleSelector,
  setZipPreferenceSelector,
  updateTemplate,
  setUpdateSelector,
  toggleZipPreference,
} from '../../services/templateSlice';
import { navigate } from 'hookrouter';
import NavBar from '../NavBar/navbar';
import EditIcon from '@material-ui/icons/Edit';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/RestoreFromTrash';
import CloseIcon from '@material-ui/icons/Close';

import { arrayMoveImmutable as arrayMove } from 'array-move';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import { Container, Draggable } from 'react-smooth-dnd';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { parseUploadedExcelSheetToJson } from '../../utils/fileUtil';
const Swal = require('sweetalert2');

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  outer: {
    margin: theme.spacing(5),
    padding: theme.spacing(1),
  },

  tooltip: {
    fontSize: '1em',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  pos: {
    marginBottom: 12,
  },
  textfield: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  gridpaper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  fieldpos: {
    fontSize: '20px',
  },
  paper: {
    padding: theme.spacing(1),
  },
  dialogBox: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  header: {
    margin: theme.spacing(2),
  },
  btn: {
    margin: theme.spacing(3),
  },
  root: {
    padding: theme.spacing(3),
    '& .MuiFormControl-root': {
      width: '100%',
      textAlign: 'left',
      padding: '0',
    },
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  dragHandle: {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  draggable: {
    overflow: 'unset !important',
  },
}));

const columns = [
  { id: 'name', label: 'Template Name', minWidth: 170, sortable: false },
  { id: 'version', label: 'Template Version', minWidth: 170, sortable: false },
  { id: 'count', label: 'Rows count', minWidth: 170 },
  { id: 'createdBy', label: 'Created By', minWidth: 170, sortable: false },
  { id: 'created', label: 'Created On', minWidth: 170, sortable: false },
  { id: 'updated', label: 'Updated On', minWidth: 170, sortable: false },
  { id: 'active', label: 'Active Template', minWidth: 100, sortable: false },
  { id: 'exactzipsearch', label: 'Exact Zip Search', minWidth: 100, sortable: false },
  { id: 'forms', label: 'Actions', minWidth: 170, sortable: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.id}
            align={column.numeric ? 'right' : 'left'}
            padding={column.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === column.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === column.id}
              direction={orderBy === column.id ? order : 'asc'}
              onClick={createSortHandler(column.id)}
            >
              {column.label}
              {orderBy === column.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default function CreateAndUpload() {
  if (localStorage.getItem('auth') !== 'true') {
    navigate('/', true);
  }

  const dispatch = useDispatch();

  const uploadResponse = useSelector(setUploadSelector);
  const specificTemplateResponse = useSelector(getSelectedTemplateSelector);
  const getInstanceResponse = useSelector(setInstanceSelector);
  const createInstanceResponse = useSelector(setCreateInstanceSelector);
  const templateIdResponse = useSelector(setNewTemplateIdSelector);
  const templateResponse = useSelector(setCreateTemplateSelector);
  const toggleResponse = useSelector(setActiveToggleSelector);
  const zipCodePref = useSelector(setZipPreferenceSelector);
  const updateTemplateResponse = useSelector(setUpdateSelector);
  const allInstanceResponse = useSelector(setAllInstancesSelector);

  const [templateName, settemplateName] = useState('');
  const [versionName, setversionName] = useState('');
  const [templates, setTemplates] = useState([]);
  const [datatypes, setDataTypes] = useState([]);
  const [modifiedTemplateID, setmodifiedTemplateID] = useState('');
  const [customerID, setCustomerID] = useState(parseInt(localStorage.getItem('userId')));

  const [dataTypeMap, setdataTypeMap] = useState({});
  const [dataTypeFieldMapping, setdataTypeFieldMapping] = useState({});
  const api = '/api/';
  const [existingtempFields, setexistingtempFields] = useState([]);
  const [dispatched, setDispatched] = useState(false);
  const [open, setOpen] = useState(false);
  const [upload, setUpload] = useState(false);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('count');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [disabledTemplatesPage, setDisabledTemplatesPage] = useState(0);
  const [disabledTemplatesRowsPerPage, setDisabledTemplatesRowsPerPage] = useState(10);
  const [uploadedFields, setUploadedFields] = useState([]);
  const [csv, setCsv] = useState(false);
  const [parsedExcelJsonDataList, setParsedExcelJsonDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [dialogMessage, setdialogMessage] = useState('');
  const [uploadedFileName, setuploadedFileName] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [showDisabled, setShowDisabled] = useState(false);

  const [selectedFordisableTemplateDetails, setSelectedFordisableTemplateDetails] = useState(null);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = templates.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleSubmit = (e) => {
    if (templateName.length === 0 || versionName.length === 0 || uploadedFileName === '') {
      return;
    }
    setUpload(false);
    setLoading(true);
    setdialogMessage('Uploading Template');
    e.preventDefault();
    submitForm();
  };

  const handleSwitchChange = (event) => {
    dispatch(toggleActive(event.target.name));
  };

  const handleZipPreferenceChange = (event) => {
    dispatch(toggleZipPreference(event.target.name));
  };

  useEffect(() => {
    if (toggleResponse.length !== 0) {
      Swal.fire({
        text: 'Changed the state',
        icon: 'success',
      }).then((result) => {
        dispatch(resetTemplateStates());
        if (localStorage.getItem('auth') !== 'true') {
          navigate('/', true);
        }
        dispatch(getExisitingTemplates(customerID));
      });
    }
  }, [toggleResponse]);

  useEffect(() => {
    if (zipCodePref.length !== 0) {
      Swal.fire({
        text: 'Changed the state',
        icon: 'success',
      }).then((result) => {
        dispatch(resetTemplateStates());
        if (localStorage.getItem('auth') !== 'true') {
          navigate('/', true);
        }
        dispatch(getExisitingTemplates(customerID));
      });
    }
  }, [zipCodePref]);

  useEffect(() => {
    if (uploadedFields.length !== 0) {
      setLoading(false);
      setdialogMessage('');
    }
  }, [uploadedFields]);

  const submitForm = () => {
    let formDetails = {
      name: templateName,
      version: versionName,
      customer: customerID,
      createdBy: localStorage.getItem('username'),
    };

    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    dispatch(createTemplateId(formDetails));
  };

  useEffect(() => {
    if (templateIdResponse !== '') {
      setmodifiedTemplateID(templateIdResponse);
      createTemplate(uploadedFields, templateIdResponse);
    }
  }, [templateIdResponse]);

  const createTemplate = (uploadedFields, id) => {
    let data = [];

    uploadedFields.map((entry) =>
      data.push({
        name: entry.question,
        template: id,
        type: entry.type,
        isSearchable: entry.isSearchable,
        isMany: entry.isMany,
        order: 0,
      }),
    );

    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    dispatch(addTemplate(data));
  };

  const editTemplate = (id) => {
    fetchDetailsforModification(id);
    setEdit(true);
  };

  const downloadDataForTemplate = (templateId) => {
    setAlertSeverity('success');
    setAlertMessage('Download will start soon');
    let data = {};
    data['attributeSearchItems'] = [{ attributeName: '', searchString: '', isGlobal: true }];
    data['templateId'] = templateId;
    axios
      .post(api + 'instance/download/category/multiple/v4/' + customerID, data, {
        headers: {
          'Content-Type': 'application/json',
          responseType: 'blob',
        },
      })
      .then((response) => {
        jsFileDownload(response.data, 'download.csv');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpen = (id) => {
    fetchDetailsforModification(id);
    setOpen(true);
    setdialogMessage('Loading Template');
    setLoading(true);
  };

  const toggleTemplateStatus = (templateId) => {
    axios.post(api + 'template/toggledisabled/' + templateId).then((response) => {
      if (response.data === '') {
        setSelectedFordisableTemplateDetails(null);
        setDispatched(false);
      } else {
        setAlertSeverity('error');
        setAlertMessage(response.data);
        setSelectedFordisableTemplateDetails(null);
      }
    });
  };

  const handleTemplateStatusToggle = (
    templateId,
    templateName,
    templateVersion,
    currentDisableStatus,
  ) => {
    setSelectedFordisableTemplateDetails({
      templateId,
      templateName,
      templateVersion,
      currentDisableStatus,
    });
  };

  useEffect(() => {
    if (templateResponse.length !== 0) {
      setexistingtempFields([]);
      dispatch(resetTemplateStates());
      setCsv(true);

      fetchDetailsforModification(modifiedTemplateID);
    }
  }, [templateResponse]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDisabledTemplateChangePage = (event, newPage) => {
    setDisabledTemplatesPage(newPage);
  };

  const handleChangeDisabledTemplateRowsPerPage = (event) => {
    setDisabledTemplatesRowsPerPage(parseInt(event.target.value, 10));
    setDisabledTemplatesPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const hiddenFileInput = useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const processData = (parsedJsonDataList) => {
    if (parsedJsonDataList?.length > 0) {
      setParsedExcelJsonDataList(parsedJsonDataList);
      const excelDataHeaders = Object.keys(parsedJsonDataList[0]);
      let tempList = [];
      for (var name of excelDataHeaders) {
        tempList.push({
          id: uuidv4(),
          question: name,
          type: datatypes?.filter((option) => option.name == 'Text')[0].id,
          isMany: false,
          isSearchable: true,
          isValid: true,
        });
      }
      setUploadedFields(tempList);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file !== '') {
      setuploadedFileName(file.name);
    }
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const workbook = XLSX.read(bstr, {
        type: 'binary',
        raw: true, // Keep raw values to avoid date conversion
        cellDates: true,
      });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = parseUploadedExcelSheetToJson(worksheet);
      processData(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  useEffect(() => {
    axios
      .get(api + 'type/')
      .then((response) => {
        var jsonResponse = response.data;
        if (datatypes.length === 0) setDataTypes(jsonResponse);
      })
      .catch((error) => {
        console.log('Fetch data types error');
      });

    updateTemplates();
  }, [datatypes]);

  useEffect(() => {
    if (existingtempFields?.length !== 0) {
      setdialogMessage('');
      setLoading(false);
    }
  }, [existingtempFields]);

  if (!dispatched) {
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    setdialogMessage('Loading Templates');
    setLoading(true);
    dispatch(getExisitingTemplates(customerID));
    setDispatched(true);
  }

  useEffect(() => {
    if (uploadResponse === null) {
      setdialogMessage('Loading Templates');
      setLoading(true);
    } else if (uploadResponse.length != 0) {
      setLoading(false);
      setdialogMessage('');
      setTemplates(uploadResponse);
    } else if (uploadResponse.length === 0) {
      setTemplates([]);
      setLoading(false);
      setdialogMessage('');
    }
  }, [uploadResponse]);

  const handleModify = (e) => {
    e.preventDefault();

    initiateSubmit(existingtempFields);
  };

  const updateTemplates = () => {
    let types = {};
    let fieldMap = {};

    datatypes.map((type) => (types[type.id] = type.name));

    for (const [key, value] of Object.entries(types)) {
      if (value === 'Number') {
        fieldMap[value] = 'number';
      } else {
        fieldMap[value] = 'text';
      }
    }

    setdataTypeMap(types);
    setdataTypeFieldMapping(fieldMap);
  };

  const initiateSubmit = () => {
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }

    dispatch(getInstanceById({ template: modifiedTemplateID }));
  };

  useEffect(() => {
    if (getInstanceResponse.length != 0) {
      let jsonData = getInstanceResponse;
      if (!csv) {
        var tempFields = existingtempFields;

        let attrValues = [];
        let attrcontent = [];
        let attributes = [];
        let data = {};
        let tempdata = [];

        tempFields.map((attr) => attributes.push(attr));

        attributes.map((val) => attrValues.push(val.attributeid));

        attributes.map((val) => attrcontent.push(val.value));

        for (let i = 0; i < attrValues.length; i++) {
          if (attrValues[i] in data) {
            data[attrValues[i]] += ',' + attrcontent[i];
          } else {
            data[attrValues[i]] = attrcontent[i];
          }
        }

        for (const [key, value] of Object.entries(data)) {
          let data = {
            templateAttribute: parseInt(key),
            content: value,
            instance: jsonData.id,
          };
          tempdata.push(data);
        }
        if (localStorage.getItem('auth') !== 'true') {
          navigate('/', true);
        }
        dispatch(createInstance(tempdata));
      }
    }
  }, [getInstanceResponse]);

  useEffect(() => {
    if (createInstanceResponse.length !== 0) {
      handleClose();
      handleUploadClose();
      setmodifiedTemplateID('');
      Swal.fire({
        icon: 'success',
        title: 'Search Template submission',
        text: 'Operation successful',
      }).then((result) => {
        dispatch(resetUploadStates());
        setCsv(false);
      });
    }
  }, [createInstanceResponse]);

  useEffect(() => {
    dispatch(resetUploadStates());
    setdialogMessage('Loading Templates');
    setLoading(true);
  }, []);

  useEffect(() => {
    let flag = 0;
    if (allInstanceResponse.length !== 0) {
      handleClose();
      handleUploadClose();
      setLoading(false);
      flag = 1;
      Swal.fire({
        icon: 'success',
        title: 'Search Template submission',
        text: 'Upload initiated Successfully',
      }).then((result) => {
        dispatch(resetUploadStates());
        dispatch(resetTemplateStates());
        setuploadedFileName('');
        setUploadedFields([]);
        setCsv(false);
        if (localStorage.getItem('auth') !== 'true') {
          navigate('/', true);
        }
        setTemplates([]);
        navigate('/uploads/' + modifiedTemplateID);
        setmodifiedTemplateID('');
        dispatch(getExisitingTemplates(customerID));
      });
    } else if (allInstanceResponse.length === 0 && !loading && flag == 1) {
      handleClose();
      handleUploadClose();
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Search Template submission',
        text: 'Could not upload data',
      }).then((result) => {
        dispatch(resetUploadStates());
        dispatch(resetTemplateStates());
        setCsv(false);
        if (localStorage.getItem('auth') !== 'true') {
          navigate('/', true);
        }
        dispatch(getExisitingTemplates(customerID));
      });
    }
  }, [allInstanceResponse]);

  const handleChangeInput = (id, event) => {
    const newTempFields = uploadedFields.map((i) => {
      if (event.target.name === 'isMany' && id === i.id) {
        i['isMany'] = event.target.checked;
      } else if (event.target.name === 'isSearchable' && id === i.id) {
        i['isSearchable'] = event.target.checked;
      } else if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setUploadedFields(newTempFields);
  };

  const handleDeleteInput = (id) => {
    const newTemplateFields = uploadedFields.filter((item) => item.id != id);
    setUploadedFields(newTemplateFields);
  };

  const handleChangeInputForExisting = (id, event) => {
    const newTempFields = existingtempFields.map((i) => {
      if (event.target.name === 'isMany' && id === i.id) {
        i['isMany'] = event.target.checked;
      } else if (event.target.name === 'isSearchable' && id === i.id) {
        i['isSearchable'] = event.target.checked;
      } else if (event.target.name === 'isDefault' && id === i.id) {
        i['isDefault'] = event.target.checked;
      } else if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setexistingtempFields(newTempFields);
  };

  const handleEdit = () => {
    setdialogMessage('Editing Template');
    setLoading(true);
    let data = [];
    existingtempFields.map((entry) =>
      data.push({
        id: entry.attributeid,
        type: entry.type,
        isSearchable: entry.isSearchable,
        isMany: entry.isMany,
        isDefault: entry.isDefault,
      }),
    );
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    dispatch(updateTemplate(data));
  };

  useEffect(() => {
    if (updateTemplateResponse === 'Error') {
      setLoading(false);
      handleEditClose();
      Swal.fire({
        text: 'Cannot modify one or more fields to ZIP type',
        icon: 'error',
      }).then((result) => {
        dispatch(resetTemplateStates());
      });
    } else if (updateTemplateResponse.length !== 0) {
      setLoading(false);
      handleEditClose();
      Swal.fire({
        text: 'The template has been edited successfully',
        icon: 'success',
      }).then((result) => {
        dispatch(resetTemplateStates());
      });
    }
  }, [updateTemplateResponse]);

  const handleAddFieldsForExisting = (inputField) => {
    setexistingtempFields([
      ...existingtempFields,
      {
        id: uuidv4(),
        question: inputField.question,
        type: inputField.type,
        isMany: inputField.isMany,
        isDefault: inputField.isDefault,
        isSearchable: inputField.isSearchable,
        value: inputField.value,
        attributeid: inputField.attributeid,
      },
    ]);
  };

  const handleRemoveFieldsForExisting = (id) => {
    const values = [...existingtempFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1,
    );
    setexistingtempFields(values);
  };

  const handleClose = () => {
    setOpen(false);
    setexistingtempFields([]);
  };

  const handleUploadClose = () => {
    setUpload(false);
    setuploadedFileName('');
    setUploadedFields([]);
  };

  const handleEditClose = () => {
    setEdit(false);
    setexistingtempFields([]);
  };

  const fetchDetailsforModification = (modifiedTemplateID) => {
    setmodifiedTemplateID(modifiedTemplateID);
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    setdialogMessage('Loading Template');
    setLoading(true);
    dispatch(getSpecificTemplates(modifiedTemplateID));
  };

  const openUploadDialog = () => {
    setUpload(true);
  };

  useEffect(() => {
    if (specificTemplateResponse.length != 0) {
      if (!csv) {
        let fields = [];
        var jsonResponse = specificTemplateResponse;
        setdialogMessage('');
        setLoading(false);
        jsonResponse.map((res) =>
          fields.push({
            id: uuidv4(),
            question: res.name,
            type: res.type.id,
            isMany: res.isMany,
            isSearchable: res.isSearchable,
            value: '',
            attributeid: res.id,
            isDefault: res.isDefault,
          }),
        );
        setexistingtempFields(fields);
        dispatch(resetTemplateStates());
      } else {
        let fields = [];
        jsonResponse = specificTemplateResponse;
        jsonResponse.map((res) => fields.push(res.id));
        let selectedColums = {};
        jsonResponse.forEach((res) => (selectedColums[res.name] = res.id));

        var payload = [];
        const selectedTemplateHeaders = specificTemplateResponse.reduce((acc, ele) => {
          acc[ele.name] = ele.id;
          return acc;
        }, {});
        parsedExcelJsonDataList?.forEach((eachData) => {
          let temp = [];
          if (eachData && Object.keys(eachData)?.length > 0) {
            Object.keys(eachData).forEach((key) => {
              if (Object.keys(selectedTemplateHeaders).includes(key))
                temp.push({
                  templateAttribute: selectedTemplateHeaders[key],
                  content: eachData[key],
                });
            });
          }
          payload.push(temp);
        });
        const data = {
          payload: payload,
          username: localStorage.getItem('username'),
          templateId: modifiedTemplateID,
          filename: escape(uploadedFileName),
        };

        if (localStorage.getItem('auth') !== 'true') {
          navigate('/', true);
        }
        dispatch(createInstanceMultiple(data));
      }
    }
  }, [specificTemplateResponse]);

  const onDrop = ({ removedIndex, addedIndex }) => {
    setexistingtempFields(arrayMove(existingtempFields, removedIndex, addedIndex));
  };

  const classes = useStyles();
  useRoutes(Routes);

  const TemplateTableContainer = ({
    isDisabledTemplates,
    templatesList,
    page,
    rowsPerPage,
    order,
    orderBy,
    classes,
    selected,
  }) => {
    return (
      <>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={templatesList.length}
            />
            <TableBody>
              <Paper elevation={0} style={{ margin: '20px' }}>
                {!loading && templatesList && templatesList.length === 0
                  ? 'No templates found for the customer'
                  : ''}
              </Paper>
              {stableSort(templatesList, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      <TableCell>{row.template.name}</TableCell>
                      <TableCell>{row.template.version}</TableCell>
                      <TableCell>{row.count}</TableCell>
                      <TableCell>{row.template.createdBy}</TableCell>
                      <TableCell>{new Date(row.template.createdOn).toLocaleString()}</TableCell>
                      <TableCell>{new Date(row.template.updatedOn).toLocaleString()}</TableCell>
                      <TableCell>
                        <Switch
                          checked={row.template.isActive}
                          name={row.template.id}
                          onChange={handleSwitchChange}
                        />
                      </TableCell>
                      <TableCell>
                        <Switch
                          checked={row.template.exactZipSearch}
                          name={row.template.id}
                          onChange={handleZipPreferenceChange}
                        />
                      </TableCell>
                      <TableCell>
                        <Tooltip classes={{ tooltip: classes.tooltip }} title="Download as CSV">
                          <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '5px', marginTop: '5px' }}
                            onClick={() => downloadDataForTemplate(row.template.id)}
                            disableElevation
                          >
                            <DownloadIcon />
                          </Button>
                        </Tooltip>
                        <Tooltip classes={{ tooltip: classes.tooltip }} title="Upload History">
                          <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '5px', marginTop: '5px' }}
                            onClick={() => {
                              setTemplates([]);
                              navigate('/uploads/' + row.template.id);
                            }}
                          >
                            <CloudIcon />
                          </Button>
                        </Tooltip>
                        <Tooltip classes={{ tooltip: classes.tooltip }} title="Edit Data">
                          <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '5px', marginTop: '5px' }}
                            startIcon={<EditIcon />}
                            onClick={() => {
                              navigate('/data/' + customerID + '/' + row.template.id);
                            }}
                            disableElevation
                          >
                            Data
                          </Button>
                        </Tooltip>
                        <Tooltip classes={{ tooltip: classes.tooltip }} title="Edit Template">
                          <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '5px', marginTop: '5px' }}
                            startIcon={<EditIcon />}
                            onClick={() => editTemplate(row.template.id)}
                            disableElevation
                          >
                            Template
                          </Button>
                        </Tooltip>
                        <Tooltip classes={{ tooltip: classes.tooltip }} title="Fill Data">
                          <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '5px', marginTop: '5px' }}
                            startIcon={<TextFieldsIcon />}
                            onClick={() => handleOpen(row.template.id)}
                            disableElevation
                          >
                            Fill
                          </Button>
                        </Tooltip>
                        <Tooltip classes={{ tooltip: classes.tooltip }} title="Disable Customer">
                          <Button
                            variant="outlined"
                            color={row.template.isDisabled ? 'default' : 'secondary'}
                            style={{ marginRight: '0px', marginTop: '5px' }}
                            onClick={() =>
                              handleTemplateStatusToggle(
                                row.template.id,
                                row.template.name,
                                row.template.version,
                                row.template.isDisabled,
                              )
                            }
                            disableElevation
                          >
                            {row.template.isDisabled ? <RestoreIcon /> : <DeleteIcon />}
                          </Button>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 25]}
          component="div"
          count={templatesList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={isDisabledTemplates ? handleDisabledTemplateChangePage : handleChangePage}
          onChangeRowsPerPage={
            isDisabledTemplates ? handleChangeDisabledTemplateRowsPerPage : handleChangeRowsPerPage
          }
        />
      </>
    );
  };

  return (
    <div>
      <NavBar />
      <Box className={classes.outer} boxShadow={5}>
        <Button
          variant="contained"
          startIcon={<CloudUploadIcon />}
          color="primary"
          onClick={openUploadDialog}
          className={classes.btn}
        >
          Create and Upload Data via File
        </Button>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          color="default"
          onClick={() => {
            setTemplates([]);
            navigate('/create/' + localStorage.getItem('userId'));
          }}
          className={classes.btn}
        >
          Create Template
        </Button>
        <Button
          variant="outlined"
          color="default"
          startIcon={<CloudUploadIcon />}
          onClick={() => {
            setTemplates([]);
            navigate('/upload/' + localStorage.getItem('userId'));
          }}
          className={classes.btn}
        >
          Upload Data
        </Button>

        <div style={{ textAlign: 'center', margin: '20px' }}>
          <Typography variant="h6">Available Templates</Typography>
        </div>
        <FormControlLabel
          control={
            <Switch checked={showDisabled} onChange={() => setShowDisabled(!showDisabled)}></Switch>
          }
          label="Show disabled templates"
        />

        <TemplateTableContainer
          templatesList={templates
            ?.filter((item) => !item?.template?.isDisabled)
            ?.sort((a, b) => b?.template?.isActive - a?.template?.isActive)}
          page={page}
          rowsPerPage={rowsPerPage}
          order={order}
          orderBy={orderBy}
          classes={classes}
          selected={selected}
          isDisabledTemplates={false}
        />

        {showDisabled ? (
          <>
            <Typography variant="h6">Disabled Templates</Typography>
            <TemplateTableContainer
              templatesList={templates?.filter((item) => item?.template?.isDisabled)}
              page={disabledTemplatesPage}
              rowsPerPage={disabledTemplatesRowsPerPage}
              order={order}
              orderBy={orderBy}
              classes={classes}
              selected={selected}
              isDisabledTemplates={true}
            />
          </>
        ) : null}

        <Dialog open={loading}>
          <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
            {(dialogMessage === 'Editing Template' ||
              dialogMessage === 'Loading Templates' ||
              dialogMessage === 'Loading Template' ||
              dialogMessage === 'Reading Columns') && <CircularProgress />}
            <Typography variant="h6">{dialogMessage}</Typography>
          </DialogContent>
        </Dialog>

        <Dialog open={open} fullWidth={true} maxWidth={'md'} onClose={handleClose}>
          <DialogContent className={classes.dialogBox}>
            <Typography variant="h6" className={classes.header}>
              Template Entities
            </Typography>
            <form className={classes.root} onSubmit={handleModify}>
              {existingtempFields.map((inputField) => (
                <div key={inputField.id}>
                  <Grid container spacing={6}>
                    <Grid item md={2} sm={12} xs={12}>
                      <Typography style={{ marginTop: '13px' }}>{inputField.question}</Typography>
                    </Grid>
                    <Grid item md={2} sm={12} xs={12}>
                      <Typography style={{ marginTop: '13px' }}>
                        {dataTypeMap[inputField.type]}
                      </Typography>
                    </Grid>
                    <Grid item md={5} sm={12} xs={12}>
                      <TextField
                        name="value"
                        label="value"
                        variant="outlined"
                        type={dataTypeFieldMapping[dataTypeMap[inputField.type]]}
                        onChange={(event) => handleChangeInputForExisting(inputField.id, event)}
                      />
                    </Grid>
                    {inputField.isMany && (
                      <Grid item md={1} sm={12} xs={12}>
                        <IconButton onClick={() => handleRemoveFieldsForExisting(inputField.id)}>
                          <RemoveIcon />
                        </IconButton>
                      </Grid>
                    )}
                    {inputField.isMany && (
                      <Grid item md={1} sm={12} xs={12}>
                        <IconButton onClick={() => handleAddFieldsForExisting(inputField)}>
                          <AddIcon />
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>
                </div>
              ))}
            </form>
            <Button
              style={{ width: '100px' }}
              color="primary"
              variant="outlined"
              size="medium"
              startIcon={<SendIcon />}
              type="submit"
              onClick={handleModify}
              className={classes.btn}
            >
              SUBMIT
            </Button>
          </DialogContent>
        </Dialog>

        <Dialog open={upload} fullWidth={true} maxWidth={'md'} onClose={handleUploadClose}>
          <DialogContent className={classes.dialogBox}>
            <div>
              <form autoComplete="off" className={classes.root}>
                <Grid container spacing={2}>
                  <Grid item md={6} sm={12} xs={12}>
                    <TextField
                      id="template-name"
                      onChange={(e) => {
                        settemplateName(e.target.value);
                      }}
                      label="Template Name"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={6} sm={12} xs={12}>
                    <TextField
                      id="template-version"
                      onChange={(e) => {
                        setversionName(e.target.value);
                      }}
                      label="Template Version Name"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </form>
              <Button onClick={handleClick} startIcon={<AttachFileIcon />} color="primary">
                Choose File
              </Button>
              {uploadedFileName && (
                <Typography variant="subtitle2" style={{ color: 'green' }}>
                  ({uploadedFileName})
                </Typography>
              )}
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileUpload}
                ref={hiddenFileInput}
                style={{ display: 'none' }}
              />
              <form className={classes.root}>
                {uploadedFields.map((inputField) => (
                  <div key={inputField.id}>
                    <Grid container spacing={6}>
                      <Grid item md={5} sm={12} xs={12}>
                        <TextField
                          name="question"
                          label="Form Name"
                          variant="outlined"
                          value={inputField.question}
                          disabled
                        />
                      </Grid>
                      <Grid item md={3} sm={12} xs={12}>
                        <TextField
                          select
                          name="type"
                          label="Type"
                          variant="outlined"
                          defaultValue={datatypes.filter((option) => option.name == 'Text')[0].id}
                          onChange={(event) => handleChangeInput(inputField.id, event)}
                        >
                          {inputField.isValid &&
                            datatypes &&
                            datatypes.map((type) => (
                              <MenuItem value={type.id}>{type.name}</MenuItem>
                            ))}
                          {inputField.isValid === false &&
                            datatypes &&
                            datatypes
                              .filter((option) => option.name !== 'Zip Code')
                              .map((type) => <MenuItem value={type.id}>{type.name}</MenuItem>)}
                        </TextField>
                      </Grid>
                      <Grid item md={3} sm={12} xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="isSearchable"
                              color="primary"
                              checked={inputField.isSearchable}
                              onChange={(event) => handleChangeInput(inputField.id, event)}
                            />
                          }
                          label="Is searchable?"
                        />
                      </Grid>
                      <Grid item md={1} sm={12} xs={12}>
                        <IconButton onClick={() => handleDeleteInput(inputField.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </div>
                ))}
              </form>
              <Button
                color="primary"
                style={{ margin: '20px' }}
                startIcon={<CloudUploadIcon />}
                variant="outlined"
                size="medium"
                type="submit"
                onClick={(e) => {
                  setUpload(false);
                  handleSubmit(e);
                }}
              >
                CREATE AND UPLOAD
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog open={edit} fullWidth={true} maxWidth={'lg'} onClose={handleEditClose}>
          <DialogContent className={classes.dialogBox}>
            <Typography variant="h4" className={classes.header}>
              Edit Template
            </Typography>
            <form className={classes.root}>
              <Container dragHandleSelector=".drag-handle" lockAxis="y" onDrop={onDrop}>
                {existingtempFields.map((inputField) => (
                  <Draggable key={inputField.id} className={classes.draggable}>
                    <Grid container spacing={4}>
                      <Grid item md={3} sm={12} xs={12}>
                        <Typography style={{ marginTop: '13px' }}>{inputField.question}</Typography>
                      </Grid>
                      <Grid item md={3} sm={12} xs={12}>
                        <TextField
                          select
                          name="type"
                          label="Type"
                          variant="outlined"
                          defaultValue={inputField.type}
                          onChange={(event) => handleChangeInputForExisting(inputField.id, event)}
                        >
                          {datatypes &&
                            datatypes.map((type) => (
                              <MenuItem value={type.id}>{type.name}</MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                      <Grid item md={2} sm={12} xs={12}>
                        <FormControlLabel
                          style={{ marginTop: '15px' }}
                          control={
                            <Checkbox
                              onChange={(event) =>
                                handleChangeInputForExisting(inputField.id, event)
                              }
                              name="isDefault"
                              color="primary"
                              defaultChecked={inputField.isDefault}
                            />
                          }
                          label="Default ?"
                        />
                      </Grid>
                      <Grid item md={2} sm={12} xs={12}>
                        <FormControlLabel
                          style={{ marginTop: '15px' }}
                          control={
                            <Checkbox
                              onChange={(event) =>
                                handleChangeInputForExisting(inputField.id, event)
                              }
                              name="isSearchable"
                              color="primary"
                              defaultChecked={inputField.isSearchable}
                            />
                          }
                          label="Is searchable?"
                        />
                      </Grid>
                      <Grid item md={2}>
                        <ListItemIcon className={`drag-handle ${classes.dragHandle}`}>
                          <DragHandleIcon />
                        </ListItemIcon>
                      </Grid>
                    </Grid>
                  </Draggable>
                ))}
              </Container>
            </form>
            <Button
              stype={{ width: '100px' }}
              color="secondary"
              variant="outlined"
              size="medium"
              onClick={() => setEdit(false)}
              startIcon={<CloseIcon />}
              className={classes.btn}
            >
              Cancel
            </Button>
            <Button
              style={{ width: '100px' }}
              color="primary"
              variant="outlined"
              size="medium"
              startIcon={<SendIcon />}
              type="submit"
              onClick={handleEdit}
              className={classes.btn}
            >
              Save
            </Button>
          </DialogContent>
        </Dialog>
      </Box>
      <Dialog open={!!selectedFordisableTemplateDetails}>
        <DialogTitle>
          {selectedFordisableTemplateDetails?.currentDisableStatus ? 'Enable' : 'Disable'} Template
        </DialogTitle>
        <DialogContent>
          Are you sure you want to{' '}
          {selectedFordisableTemplateDetails?.currentDisableStatus ? 'enable' : 'disable'} customer{' '}
          {selectedFordisableTemplateDetails?.templateName} (
          {selectedFordisableTemplateDetails?.templateVersion})
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedFordisableTemplateDetails(null)}>Cancel</Button>
          <Button
            onClick={() => toggleTemplateStatus(selectedFordisableTemplateDetails?.templateId)}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={!!alertMessage}
        autoHideDuration={2000}
        onClose={() => {
          setAlertMessage('');
        }}
      >
        <Alert severity={alertSeverity}>{alertMessage}</Alert>
      </Snackbar>
    </div>
  );
}
